import {I18n} from '@aws-amplify/core';

import {FlexiAddButton,} from '@flexinet/ui-components';

import {useNavigate, useParams} from 'react-router-dom';


export const AddRecordButton = ({
                                    buttonText = 'Add Order',
                                    size = 'sm',
                                    onClick,
                                }: {
    buttonText?: string,
    size?: string,
    onClick?: () => void
}) => {
    const navigate = useNavigate();
    const { id: customerId } = useParams();
    
    if (typeof onClick === 'undefined') {
        onClick = () => {
            const url = customerId ? `/customers/${customerId}/orders/add` : '/orders/add';
            navigate(url);
        };
    }

    return (
        <FlexiAddButton
            onClick={onClick}
            size={size}
        >
            {I18n.get(buttonText)}
        </FlexiAddButton>
    );
};

